import {Injectable} from '@angular/core';
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  validateFormControls(controls: any) {
    const controlsKeys = Object.keys(controls);
    for (const controlKey of controlsKeys) {
      const control = controls[controlKey];
      control.markAsTouched({onlySelf: true});
      control.markAsDirty({onlySelf: true});
      control.updateValueAndValidity({onlySelf: true, emitEvent: true});
    }
  }

  findAndFocusInvalidControl(controls: any, formId?: string) {
    const controlsKeys = Object.keys(controls);
    for (const controlKey of controlsKeys) {
      const control = controls[controlKey];
      if (control.invalid) {
        let el;
        if (formId) {
          el = document.querySelector(`#${formId} [formcontrolname="${controlKey}"]`) as HTMLElement;
        } else {
          el = document.querySelector(`[formcontrolname="${controlKey}"]`) as HTMLElement;
        }
        if (el) {
          el.focus();
        }
        break;
      }
    }
  }

  trimFormValues(data: any) {
    for (let key in data) {
      const value = data[key];
      if (typeof value === 'string') {
        data[key] = value.trim();
      }
    }
    return data;
  }


  nameValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const name = control.value;
      const splitName = name.split(' ').filter((value: string) => value);
      if (splitName.length < 2) {
        return {nameError: true};
      }
      // Only allow letters
      if (RegExp('\\d').test(name)) {
        return {nameError: true};
      }
      return null;
    };
  }


  zipcodeValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const zipcode = control.value;
      const parent = control.parent?.controls ?? null;
      if (!parent) {
        return null;
      }
      const countryValue = (parent as any)['country']?.value ?? null;
      if (!countryValue) {
        return null;
      }
      if (countryValue === 'DK' && !(new RegExp('^[0-9]{4}$').test(zipcode))) {
        return {zipcodeError: true};
      }
      if (countryValue === 'SE' && !(new RegExp('^[0-9]{3} ?[0-9]{2}$').test(zipcode))) {
        return {zipcodeError: true};
      }
      if (countryValue === 'NO' && !(new RegExp('^[0-9]{4}$').test(zipcode))) {
        return {zipcodeError: true};
      }
      return null;
    };
  }

  emailValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      const splitEmail = email.split('@');
      if (splitEmail.length !== 2) {
        return {emailError: true};
      }
      if (!splitEmail[1].includes('.')) {
        return {emailError: true};
      }
      return null;
    };
  }

  public validForm(form: any) {
    let valid = true;

    if (!form.valid) {
      valid = false;
    }
    return valid;
  }

  public setFocusOnFirstInvalidControl(form: any, formId?: string) {
    if (form.invalid) {
      this.findAndFocusInvalidControl(form.controls, formId);
    }
  }

  public patternValidation(pattern: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control.value;
      if (!value) {
        return null;
      }
      value = value.trim();
      const regex = new RegExp(pattern);
      if (!regex.test(value)) {
        return {patternError: true};
      }
      return null;
    };
  }
}
